import React from 'react';
import { Row } from 'react-table';
import { useLocation } from 'react-router';
import { Header } from 'layout';
import { withPlaceholder } from 'HOC';
import { ContributionDetailsState, useNavigate, useQueryParams } from 'hooks/routes';
import { useGetContributionDetails } from 'hooks/api/contributions';
import { Parameters } from 'constants/queryParameters';
import { isIraUser } from 'screens/IndependentIra/IraIndependentIra.utils';
import { EntityStatus } from 'components/Label';
import { ContributionDetailTableSign, mapData } from './ContributionDetails.columns';
import RenderContributionDetailsTable from '../components/RenderContributionDetailsTable';

import messages from './ContributionDetails.messages';

const RenderTablewithPlaceholders = withPlaceholder(RenderContributionDetailsTable);

const ContributionDetails = (): JSX.Element => {
  const { toContributionIRAUserDetail, toContributionIndependentIRAAccountDetail } =
    useNavigate();
  const contributionId = useQueryParams(Parameters.contributionId);
  const {
    data: contributionDetailsData,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useGetContributionDetails();

  const { status, transferId } =
    (useLocation().state as ContributionDetailsState | undefined) || {};

  const items = mapData(contributionDetailsData?.items);

  const onContributionDetailClick = (row: Row<ContributionDetailTableSign>) => {
    const currentItemData = contributionDetailsData?.items[row.index];

    if (
      currentItemData &&
      isIraUser(currentItemData.userProfileType) &&
      !!contributionId
    ) {
      toContributionIRAUserDetail(contributionId, String(row.original.userProfileId));
    } else {
      toContributionIndependentIRAAccountDetail(
        contributionId,
        String(row.original.userProfileId),
      );
    }
  };

  return (
    <>
      <Header
        title={`${messages.headerTitle} ${transferId ? transferId : ''}`}
        complexComponent={true}
        label={{ status, entityStatus: EntityStatus.Transfer }}
      ></Header>

      <RenderTablewithPlaceholders
        contributionDetailsData={contributionDetailsData}
        items={items}
        onDetailClick={onContributionDetailClick}
        refetch={refetch}
        isRefetching={isRefetching}
        isLoading={isLoading}
        isError={isError}
        isData={!!items && items?.length !== 0}
      />
    </>
  );
};

export default ContributionDetails;
